import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { Provider } from "jotai";
import { Masters, masterAtom } from "./atoms/masters.atom";
import { axios } from "./api/axios";
import { handleResponse } from "./utils/functions/http/handleResponse";
import { store } from "./atoms";
import { ConfigProvider } from "antd";
import { colors } from "./theme/colors";
import { Theme, themeAtom } from "./atoms/theme.atom";
import { HelmetProvider } from "react-helmet-async";

function App() {
  // Load masters
  useEffect(() => {
    axios
      .get<Masters>("/master/get/masters")
      .then((response) => {
        store.set(masterAtom, response.data);
      })
      .catch(handleResponse);
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: colors.primary.hex,
              colorBgContainer: colors.background.hex,
              colorTextBase: colors.text.hex,
              colorBorder: colors.text.withOpacity(0.6).hex,
              colorBgBase: colors.background.hex,
              colorBgElevated: colors.background.hex,
            },
            components: {
              Button: {
                boxShadow: "0px 0px transparent",
              },
              Select: colors.isDark
                ? {
                    optionSelectedBg: colors.primary.hex,
                    optionActiveBg: colors.text.withOpacity(0.5).hex,
                  }
                : {},
            },
          }}
        >
          <RouterProvider router={router} />
        </ConfigProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
